import { Box, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import Rating from "../UI/Rating";
import {useState } from "react";
import placeholderThumbnail from "../../assets/GameThumbnail_Empty.png";

import { useRef } from "react";

function GameItem({ title, thumbnail, id, rating, onHover, gameData, isPC, vidPath}) {
  const itemRef = useRef(null);
  const imageRef = useRef(null);
  const maxCharacters = 12;
  const trimmedTitle =
    title.length > maxCharacters
      ? `${title.slice(0, maxCharacters)}...`
      : title;

  //mobile
  const [showVideo, setShowVideo] = useState(false);
  const [isHolding, setIsHolding] = useState(false);
  const [holdTimeout, setHoldTimeout] = useState(null);
  const [releaseTimeout, setReleaseTimeout] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({width: 'auto', height: 'auto'});
  

  const handleMouseEnter = (e) => {
    if (onHover){
      const rect = e.currentTarget.getBoundingClientRect();
      onHover({
        game: gameData || {title, thumbnail, id, rating},
        position: {
          x: rect.right + 10,
          y: rect.top,
        },
        elementRef: itemRef,
        show: true
      });
    }
  };
  
  const handleMouseLeave = () => {
    if (onHover) {
      onHover({show: false});
    }
  };

  const resetVideoState=()=>{
    if(holdTimeout){
      clearTimeout(holdTimeout);
      setHoldTimeout(null);
    }
    if(releaseTimeout){
      clearTimeout(releaseTimeout);
      setReleaseTimeout(null);
    }
    setIsHolding(false);
    setShowVideo(false);
    if(!isPC&&onHover){
      onHover({show: false})
    }
  };

  //mobile handlers
  const handleTouchStart = (e) => {
    e.preventDefault(); 
    
    if(imageRef.current) {
      const imageRect = imageRef.current.getBoundingClientRect();
      setImageDimensions({
        width: imageRect.width,
        height: imageRect.height
      });
    }
    
    const timeout = setTimeout(() => {
      setIsHolding(true);
      setShowVideo(true);
      if (!isPC && onHover) {
        const rect = e.currentTarget.getBoundingClientRect();
        onHover({
          game: gameData || {title, thumbnail, id, rating},
          position: {
            x: rect.right + 10,
            y: rect.top,
          },
          elementRef: itemRef,
          show: true
        });
      }
    }, 500); //hold time
    setHoldTimeout(timeout);
  };

  const handleTouchEnd = (e) => {
      if(isHolding){
        e.preventDefault();
        const timeout = setTimeout(()=>{
          resetVideoState()
        }, 500); //remove video upon 500ms of not holding

        setReleaseTimeout(timeout);
      } else {
        resetVideoState();
      }
  };

  const handleTouchCancel = () => {
    resetVideoState();
  };

  const handleTouchMove = (e) => {
    if (itemRef.current && e.touches.length > 0 && (holdTimeout || isHolding)) {
      const touch = e.touches[0];
      const rect = itemRef.current.getBoundingClientRect();
      
      const isInsideContainer = (
        touch.clientX >= rect.left &&
        touch.clientX <= rect.right &&
        touch.clientY >= rect.top &&
        touch.clientY <= rect.bottom
      );
      
      if (!isInsideContainer) {
        if (isHolding && !releaseTimeout) {
          const timeout = setTimeout(() => {
            resetVideoState();
          }, 500); 
          
          setReleaseTimeout(timeout);
        }
      } else {
        if (releaseTimeout) {
          clearTimeout(releaseTimeout);
          setReleaseTimeout(null);
        }
      }
    }
  }

  if (!isPC) {
    return (
      <Box
        ref={itemRef}
        as={Link}
        to={`/games/${id}`}
        color='white'
        borderRadius='8px'
        boxShadow='0 4px 8px lightgray'
        padding='4px'
        pb='12px'
        bgColor={isHolding ? "#154a78" : 'primary'}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onTouchCancel={handleTouchCancel}
        onTouchMove={handleTouchMove}
        style={{
            textDecoration: isHolding ? 'underline' : 'none',
            cursor: isHolding ? 'pointer' : 'default'
        }}
    >
        {showVideo && vidPath ? (
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                    width: imageDimensions.width,
                    height: imageDimensions.height,
                    borderRadius: '8px',
                    marginBottom: '16px',
                    objectFit: 'cover'
                }}
            >
                <source src={vidPath} type="video/mp4" />
            </video>
        ) : (
            <Image
                ref={imageRef}
                onLoad={(e) => (e.target.src = thumbnail)}
                marginBottom='16px'
                borderRadius='8px'
                alt={title}
                src={placeholderThumbnail}
                loading='lazy'
            />
        )}
        <div style={{display: 'none'}}>
            <Rating justifyContent='center' rating={rating} />
        </div>
        <Text textAlign='center' fontSize='xl'>
            {trimmedTitle}
        </Text>
      </Box>
    )
  }

  return (
    <Box
      ref={itemRef}
      as={Link}
      to={`/games/${id}`}
      color='white'
      borderRadius='8px'
      boxShadow='0 4px 8px lightgray'
      padding='4px'
      pb='12px'
      bgColor='primary'

      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}

      _hover={{
        cursor: "pointer",
        textDecoration: "underline",
        bgColor: "#154a78"
      }}
    >
      <Image
        onLoad={(e) => (e.target.src = thumbnail)}
        marginBottom='16px'
        borderRadius='8px'
        alt={title}
        src={placeholderThumbnail}
        loading='lazy'
      />
      <div style={{display: 'none'}}>
        <Rating justifyContent='center' rating={rating} />
      </div>
      <Text textAlign='center' fontSize='xl'>
        {trimmedTitle}
      </Text>
    </Box>
  );
}

export default GameItem;
